/*
 *
 * utilities for mobile documents
 *
 */

export const getRowHeight = () => 60;
